import { createWelfareBenefitsQuery } from 'components/SearchSideBar/logics/createQuery/details/welfareBenefits';
import { GetInitialIdListArgument } from 'components/SearchSideBar/types';

/**
 * id配列を取得
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.queries クエリパラメータ
 * @returns {string[]} id配列を取得
 */
export const getInitialIdList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
}: GetInitialIdListArgument) => {
  // 保存した検索条件
  if (savedSearchCondition) {
    const idList = savedSearchCondition.welfareBenefitsList
      ? createWelfareBenefitsQuery(savedSearchCondition.welfareBenefitsList)
      : [];

    return idList;
  }

  // 特集枠検索条件
  if (featuredSearchCondition) {
    const idList = featuredSearchCondition.welfareBenefits
      ? createWelfareBenefitsQuery(featuredSearchCondition.welfareBenefits)
      : [];

    return idList;
  }

  // クエリから取得した検索条件
  return queries ?? [];
};
